import { render, staticRenderFns } from "./panel-template.vue?vue&type=template&id=6c4e2178&"
import script from "./panel-template.vue?vue&type=script&lang=ts&"
export * from "./panel-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports